import type { TypedClient } from '@platform/openapi';
import { usePageContext } from '../usePageContext.ts';
import { DepotSheet } from './DepotSheet.tsx';
import { useDepotChanges } from './depots.ts';
import type { Location } from './inventory.ts';

export type NewDepotSheetProps = {
  api: TypedClient;
  onCreated: (depot: Location) => void;
  onClose: () => void;
};

export const NewDepotSheet = ({ api, onCreated, onClose }: NewDepotSheetProps) => {
  const { describeError } = usePageContext();
  const changes = useDepotChanges(api);
  return (
    <DepotSheet
      api={api}
      depot={null}
      details={null}
      submitting={changes.isPending}
      errorMessage={changes.isError ? (describeError(changes.error) ?? null) : null}
      onClose={onClose}
      onSubmit={(body) => {
        changes.mutate({ kind: 'save', depot: null, body }, { onSuccess: onCreated });
      }}
    />
  );
};
